import React from 'react';
import { Menu, Button, Space } from 'antd';
import { SearchOutlined, UserOutlined, LogoutOutlined, SettingOutlined, DownloadOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, userInfo } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: '/search',
      icon: <SearchOutlined />,
      label: '搜索',
      onClick: () => navigate('/search')
    },
    {
      key: '/download-manager',
      icon: <DownloadOutlined />,
      label: '代下载管理',
      onClick: () => navigate('/download-manager')
    }
  ];

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      padding: '0 50px',
      height: '100%'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h1 style={{ 
          color: '#fff', 
          margin: 0, 
          fontSize: '20px',
          fontWeight: '500',
          cursor: 'pointer'
        }} onClick={() => navigate('/')}>
          电影搜索
        </h1>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          style={{ 
            background: 'transparent',
            border: 'none',
            marginLeft: '40px'
          }}
        />
      </div>

      <div>
        {isAuthenticated ? (
          <Space size="middle">
            {userInfo?.is_admin && (
              <Button
                type="text"
                icon={<SettingOutlined />}
                onClick={() => navigate('/admin')}
                style={{ 
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                管理后台
              </Button>
            )}
            <Button
              type="text"
              icon={<UserOutlined />}
              onClick={() => navigate('/profile')}
              style={{ 
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              个人中心
            </Button>
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{ 
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              退出
            </Button>
          </Space>
        ) : (
          <Space>
            <Button
              type="text"
              onClick={() => navigate('/login')}
              style={{ color: '#fff' }}
            >
              登录
            </Button>
            <Button
              type="primary"
              onClick={() => navigate('/register')}
              style={{
                borderRadius: '20px',
                background: '#007AFF',
                border: 'none'
              }}
            >
              注册
            </Button>
          </Space>
        )}
      </div>
    </div>
  );
};

export default Navbar; 